import { createPlayerRuntime, type PlayerRuntime } from '@ghostscreen/player-core';
import {
  Html5PlaybackEngine,
  IndexedDbAssetStore,
  IndexedDbOfflineStateStore,
  IndexedDbPlaybackEventStore,
  LocalStorageCredentialStore,
  WebCryptoSha256Hasher,
} from '@ghostscreen/player-core/browser';
import { APP_VERSION, getApiBaseUrl } from '../config.js';
import type { IdleDisplay } from './idle-display.js';

/** Wire shared player-core for this browser kiosk shell (durable offline cache). */
export function createKioskRuntime(
  stage: HTMLElement,
  options: {
    onRevoked?: () => void;
    onIdleDisplay?: (idleDisplay: IdleDisplay) => void;
  } = {},
): PlayerRuntime {
  return createPlayerRuntime({
    apiBaseUrl: getApiBaseUrl(),
    appVersion: APP_VERSION,
    platform: 'web',
    playback: new Html5PlaybackEngine(stage),
    credentials: new LocalStorageCredentialStore(),
    assets: new IndexedDbAssetStore(),
    offlineState: new IndexedDbOfflineStateStore(),
    // Proof-of-Play queue survives reloads and offline stretches.
    playbackEventStore: new IndexedDbPlaybackEventStore(),
    hasher: new WebCryptoSha256Hasher(),
    ...(options.onRevoked ? { onRevoked: options.onRevoked } : {}),
    ...(options.onIdleDisplay ? { onIdleDisplay: options.onIdleDisplay } : {}),
  });
}
